export default "__VITE_ASSET__Ddhk0wCy__"